const setDateFormat = (date: string, dataSelect: any) => {
  return dataSelect?.filter((item: any) => item?.label === date)?.[0]?.value
}

export { setDateFormat }
